import useMutationGraphicPackingCreateUpdate from './graphic-packing-use-mutation-create-update';
import useMutationGraphicPackingDelete from './graphic-packing-use-mutation-delete';

export const graphicPackingUseMutation = {
    createUpdate: useMutationGraphicPackingCreateUpdate,
    Delete: useMutationGraphicPackingDelete
};

export default graphicPackingUseMutation;